import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import {computed, ref} from "vue";
import {useQueueStore} from "@/stores/queueStore";
import {BTableColumn, BTableOptions} from "./BTable/BTable.types";
import QueuePauseButton from "./QueuePauseButton.vue";
import {QueueItem} from "@/types";
import {BFilter, BFilterableField} from "./BFilterEditor/BFilterEditor.types";
import BGrid from "./BGrid/BGrid.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Tasks',
  props: {
    showPauseResumeButton: { type: Boolean },
    noTotal: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const queueStore = useQueueStore();
var numberOfReturnedItems = ref(0);

//table settings and column info
var tableOptions = ref({
    totalItemCount: 0,
    itemsPerPage: 25,
    page: 1,
    sortBy: [
        {
            key: "start",
            isDescending: true,
        },
    ],
    pagingMode: props.noTotal ? "noTotal" : "withTotal",
} as BTableOptions);

const columns = computed(() => {
    let data: BTableColumn[] = [];

    data.push(
        {key: "status", text: "Status", sortable: false, value: (item) => item.status},
        {key: "type", text: "Type", sortable: false, value: (item) => item.type},
        {key: "start", text: "Start", sortable: false, value: (item) => item.start},
        {key: "end", text: "End", sortable: false, value: (item) => item.end}
    );

    return data;
});

var queueItems = ref([] as QueueItem[]);
function getQueueItems() {
    queueStore
        .getQueueItems(tableOptions.value, [] as BFilter[], [] as BFilterableField[], tableOptions.value.sortBy)
        .then((response) => {
            
            if (tableOptions.value.pagingMode == "noTotal" && response?.data?.data?.length > 0) {
                //When were hiding the total text,first button, and last button then we return itemsPerPage + 1 in our get data call.
                //If the returned amount of rows is greater than itemsPerPage then enable the next button otherwise disable the next button to prevent an error
                queueItems.value = response.data.data.slice(0, tableOptions.value.itemsPerPage);
            } else {
                queueItems.value = response.data.data;
            }

            numberOfReturnedItems.value = response.data.data.length;
            
            tableOptions.value.totalItemCount = response.data.total;
        });
}

getQueueItems();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BGrid, {
      caption: "Task list",
      tableOptions: _unref(tableOptions),
      items: _unref(queueItems),
      columns: columns.value,
      "show-filter": false,
      "show-paging": true,
      "current-item-count": _unref(numberOfReturnedItems),
      onOptionChange: getQueueItems
    }, {
      beforeFilter: _withCtx(() => [
        _createVNode(QueuePauseButton, {
          "show-pause-resume-button": props.showPauseResumeButton,
          "container-class": "tasks-pause"
        }, null, 8, ["show-pause-resume-button"])
      ]),
      "cell.fileName": _withCtx(({item, column}) => [
        _createElementVNode("span", {
          innerHTML: item.fileName
        }, null, 8, _hoisted_2)
      ]),
      "cell.status": _withCtx(({item, column}) => [
        _createElementVNode("span", {
          innerHTML: item.status
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["tableOptions", "items", "columns", "current-item-count"])
  ]))
}
}

})